import { ICountry } from '@/shared/lib';

import { replacePhoneCodeOnMask } from './replacePhoneCodeOnMask';

// TODO перепроверить
export const formatPhoneNumber = (
  value: string,
  country: ICountry | null,
): string => {
  // Если нет страны или маски - возвращаем как есть
  if (!country?.mask || !country?.phoneCode || !value) return value;

  const processedMask = replacePhoneCodeOnMask(country.mask, country.phoneCode);

  // Если не удалось обработать маску - возвращаем как есть
  if (!processedMask) return value;

  // Считаем количество # в маске (ожидаемое количество цифр)
  const expectedDigitsCount = (processedMask.match(/#/g) || []).length;
  // Считаем количество цифр в введенном значении
  const currentDigitsCount = (value.replace(/\D/g, '') || '').length;

  // Если цифр нет - возвращаем пустую строку
  if (currentDigitsCount === 0) return '';

  // Форматируем только если количество цифр НЕ ПРЕВЫШАЕТ ожидаемое
  if (currentDigitsCount <= expectedDigitsCount) {
    let formattedValue = '';
    let digitIndex = 0;
    const digits = value.replace(/\D/g, '');

    for (
      let i = 0;
      i < processedMask.length && digitIndex < digits.length;
      i++
    ) {
      if (processedMask[i] === '#') {
        formattedValue += digits[digitIndex];
        digitIndex++;
      } else {
        formattedValue += processedMask[i];
      }
    }

    return formattedValue;
  }

  // Если цифр стало БОЛЬШЕ маски - возвращаем только цифры без форматирования
  return value.replace(/\D/g, '');
};
